import { useCoachingString } from '../useCoachingString'
import { useState } from 'react'
import { useApp } from '@/core/state/appStore'
import { Button, Card, Confirmation, Icon, toastError } from 'admination-react'
import { applyTbUpload, TB_EMPTY } from '../../../flows/tb'
import { getDocBucketAddress } from '@/core/data/dokumente'
import { setAufgabe } from '@/core/data/coachings'
import { handleFailure } from '@/core/lib/toast'
import { UPLOAD_ACCEPT } from '@/core/lib/fileTypes'
import { DropCard } from '@/core/components/modal/DropCard'
import { ModalHeader } from '@/core/components/modal/ModalHeader'

const getBlankTbPath = (coachingId: string) => getDocBucketAddress(coachingId, TB_EMPTY)

export function TbHochladen({ coachingId }: { coachingId: string | null }) {
  const { dispatch, reloadDashboard } = useApp()
  const [loading, setLoading] = useState(false)
  const [replacing, setReplacing] = useState(false)

  const [blankPath] = useCoachingString(coachingId, getBlankTbPath)

  async function advanceAndContinue() {
    if (coachingId) {
      try {
        await setAufgabe(coachingId, 'tbAusfuellen')
      } catch (e) {
        console.error("Aufgabe \"tbAusfuellen\" konnte nicht gesetzt werden:", e)
      }
      reloadDashboard()
    }
    dispatch({ type: "CHANGE_TAB", tab: 'bestaetigung' })
  }

  async function onFile(file: File) {
    if (!coachingId) return
    setLoading(true)
    try {
      const uploaded = await applyTbUpload(coachingId, file)
      if (!uploaded.ok) {
        handleFailure(uploaded)
        return
      }
      reloadDashboard()
      dispatch({ type: "CHANGE_TAB", tab: 'bestaetigung' })
    } catch (e) {
      console.error('TB-Upload fehlgeschlagen:', e)
      toastError('Hochladen fehlgeschlagen. Bitte erneut versuchen.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <ModalHeader size={blankPath && !replacing ? 'form' : 'document'} onClose={() => dispatch({ type: 'CLOSE' })}>
        {blankPath && !replacing && <div className="pill">
          <Button primaryAction onClick={() => void advanceAndContinue()}>
            <Icon name="i-arrow-right" />
            Weiter
          </Button>
        </div>}
      </ModalHeader>
      {blankPath === undefined ? (
        <main className="pdf-region">
          <Card className="is-overlay" isLoading loadingLabel="Trägerbestätigung wird geladen …" />
        </main>
      ) : blankPath && !replacing ? (
        <>
          <Confirmation tone="success" title="Trägerbestätigung liegt bereits vor">
            Die leere Trägerbestätigung ist bereits hinterlegt — sie kam zusammen mit dem AVGS herein.
          </Confirmation>
          <div className="confirmation-actions">
            <Button type="button" onClick={() => setReplacing(true)}>
              Ersetzen
            </Button>
          </div>
        </>
      ) : (
        <DropCard
          title="Leere Bestätigung hier ablegen"
          body="PDF oder Bild hierher ziehen oder auswählen"
          accept={UPLOAD_ACCEPT}
          onFile={onFile}
          loading={loading}
          loadingLabel="Trägerbestätigung wird hochgeladen …"
        />
      )}
    </>
  )
}
